export enum ShiftType {
    Shift_5x2 = 0,
    Shift_4x3 = 1,
    Shift_4x4 = 2,
    Shift_7x7 = 3,
    Shift_14x7 = 4,
    Shift_8x6 = 5,
    Shift_6x1 = 6,
    Shift_14x14 = 7
}

export function getShiftPatternLabel(value: number | null | undefined): string | undefined {
    return value == null ? undefined : ShiftType[value]?.replace('Shift_', '');
}
